

<div [class.example-is-mobile]="mobileQuery.matches" *ngIf="!authService?.loading else loading">
    <ng-container *ngIf="authService.authState$ | async as isAuthenticated">
      <mat-toolbar color="accent" class="toolbar" *ngIf="isAuthenticated">
        <!-- Your authenticated toolbar content -->
        <div style="display: flex;">
          <div class="title">
            <button mat-icon-button (click)="toogleSidenav()"><mat-icon>menu</mat-icon></button>
          </div>
          <h1 class="example-app-name">Safaera Partners v1.0.8</h1>
        </div>
        <button matSuffix mat-icon-button (click)="authService.signOut()">
          <mat-icon>logout</mat-icon>
        </button>
      </mat-toolbar>
    </ng-container>

  
    <mat-sidenav-container class="sidenav-container">
      <!-- MOBILE                     -->
      <mat-sidenav #sidenav id="sidenav"  [mode]="'over'"
                    class="sidenav"
                   [fixedInViewport]="true" fixedTopGap="65">
                <div *ngFor="let el of navLinks" class="sidenav-link" (click)="this.sidenav.close()" [routerLink]="el.contentLink">
                   {{el.name}}
                </div>
      </mat-sidenav>
  
    <mat-sidenav-content class="content">
        <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
<ng-template #loading >
  <div class="loading">
    <mat-spinner color="accent" diameter="40"></mat-spinner>
  </div>
</ng-template> 